import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	setOperatorsQuery,
	fetchOperators,
	deleteOperator,
	fetchOperatorRoles,
	createFiltersSuggestions
} from 'store/actions';

// Import hooks
import useFilterLogic from 'hooks/useFilterLogic';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from './operator_columns';

// Import utilities
import Search from 'components/utilities/search/Search';

// Import components
import { PanelPageTemplate } from 'components/common/templates';
import FilterButton from 'components/common/buttons/FilterButton';

const Operators = ({
	error,
	setOperatorsQuery,
	fetchOperators,
	deleteOperator,
	fetchOperatorRoles,
	createFiltersSuggestions,
	filters,
	resources
}) => {
	const { t } = useTranslation();

	const { columns } = resources;

	// Actions to fetch data for filters
	const filterActions = {
		fetchOperatorRoles
	};

	// execute filters logic
	useFilterLogic({
		filterActions,
		createFiltersSuggestions,
		filters
	});

	return (
		// Dispatch fetchOperator, deleteOperator action in operators_panel
		<PanelPageTemplate
			title="Lista"
			error={error}
			type="operators"
			addLinkText={t('operators:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchOperators}
			deleteItemAction={deleteOperator}
			notificationDeleteSuccessTxt={t('operators:notification.delete_success')}
			notificationDeleteErrorTxt={t('operators:notification.delete_error')}
		>
			<div className="d-flex justify-content-end">
				<Search
					setQueryValue={setOperatorsQuery}
					value={resources.options.filters.query}
				/>
				<FilterButton tableColumns={columns} />
			</div>
		</PanelPageTemplate>
	);
};

Operators.propTypes = {
	error: PropTypes.bool.isRequired,
	setOperatorsQuery: PropTypes.func.isRequired,
	resources: PropTypes.object.isRequired,
	fetchOperators: PropTypes.func.isRequired,
	deleteOperator: PropTypes.func.isRequired,
	fetchOperatorRoles: PropTypes.func.isRequired,
	createFiltersSuggestions: PropTypes.func.isRequired,
	filters: PropTypes.object
};

const mapStateToProps = (state) => {
	return {
		error: state.operators.table.error,
		resources: state.operators.table,
		filters: { roles: state.operators.form.roles }
	};
};

export default connect(mapStateToProps, {
	setOperatorsQuery,
	fetchOperators,
	deleteOperator,
	fetchOperatorRoles,
	createFiltersSuggestions
})(Operators);
